module.exports = {
    "bas": {
        "title": "Online BAS Program Guide",
        "thumbnail": "/assets/images/thumbnails/bas.jpg",
        "document": "/assets/docs/Clarke Online BAS.pdf",
        "teaser": "Get more details about **admissions requirements**, the **courses you’ll take**, how to save time and money with **transfer credits**, and your next steps."
    }
}